<div class="d-flex">
  <span *ngFor="let number of [1,2,3,4,5]; let i = index">
    <i class="fad fa-circle" [style.--fa-primary-color]="i < importance ? priorityColors[importance]: 'var(--zint-grey-100)'" style="--fa-secondary-color: 'var(--zint-grey-400)';" [ngClass]="shownInTopPanel ? 'top-level': null"></i>
  </span>
</div>